import inView from 'in-view/dist/in-view.min';

export function tileanim() {
  inView('.teaser .image')
    .on('enter', el => {
      $(el).addClass('in-view');
    })
    .on('exit', el => {
      $(el).removeClass('in-view');
    });

  function anim() {
    var st = $(window).scrollTop();
    var wh = $(window).height();
    setTimeout(() => {
      $('.in-view').each(function() {
        var top = $(this).offset().top;
        var diff = st - top + wh;
        var p = diff * 100 / wh;
        var margin = (-120 * p / 100) + 60;
        $(this).css('top',margin * 0.5)
      });
    },100)
  }

  anim();

  $(window).scroll(function () {
    var st = $(this).scrollTop();
    var wh = $(this).height();

    $('.in-view').each(function() {
      var top = $(this).offset().top;
      var diff = st - top + wh;
      var p = diff * 100 / wh;
      var margin = (-120 * p / 100) + 60;
      $(this).css('top',margin * 0.5)
    });
  });
}



// WEBPACK FOOTER //
// ./scripts/components/tileanim.js